import { dispatchWithAuth } from './project_actions';

export function fetchSetup () {
  const url = '/setup';
  return dispatch => dispatchWithAuth(dispatch)({ url }, 'FETCH_SETUP_FULFILLED')
}
